import { motion } from "framer-motion";
import { reveal, VIEW_ONCE } from "./motion";

export const Overline = ({ children, className = "" }) => (
  <p className={`font-mono text-[11px] uppercase tracking-[0.45em] text-[#06B6D4] ${className}`}>
    {children}
  </p>
);

export const StatusTag = ({ children, tone = "neutral" }) => {
  const tones = {
    neutral: "border-white/15 text-[#F4F6FB]/60",
    concept: "border-[#D4AF37]/40 text-[#D4AF37]",
    live: "border-[#06B6D4]/50 text-[#06B6D4]",
  };
  return (
    <span
      className={`inline-block rounded-full border bg-[#0B0C10]/50 px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.28em] backdrop-blur-md ${tones[tone]}`}
    >
      {children}
    </span>
  );
};

export const statusTone = (status) =>
  status?.startsWith("CONCEPT") ? "concept" : status === "LIVE PROJECT" ? "live" : "neutral";

export const SectionHeading = ({ overline, title, lead, id, testId }) => (
  <motion.div
    id={id}
    data-testid={testId}
    variants={reveal}
    initial="hidden"
    whileInView="show"
    viewport={VIEW_ONCE}
  >
    <Overline className="mb-6">{overline}</Overline>
    <h2 className="font-display max-w-3xl text-3xl font-bold leading-tight text-[#F4F6FB] md:text-5xl">
      {title}
    </h2>
    {lead && (
      <p className="mt-6 max-w-2xl text-sm leading-relaxed text-[#F4F6FB]/55 md:text-base">{lead}</p>
    )}
  </motion.div>
);

export const PageTitle = ({ overline, title, lead, testId }) => (
  <div>
    <Overline className="mb-6">{overline}</Overline>
    <h1
      data-testid={testId}
      className="font-display max-w-4xl bg-gradient-to-r from-[#F4F6FB] via-[#c9b8f5] to-[#7dd8ea] bg-clip-text text-4xl font-black uppercase leading-[1.04] tracking-tight text-transparent md:text-6xl"
    >
      {title}
    </h1>
    {lead && (
      <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#F4F6FB]/70 md:text-xl">{lead}</p>
    )}
  </div>
);

export const Panel = ({ children, className = "", ...rest }) => (
  <div
    className={`rounded-2xl border border-white/10 bg-[#12141C]/55 p-8 backdrop-blur-xl md:p-10 ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export const Section = ({ id, testId, children, className = "" }) => (
  <section
    id={id}
    data-testid={testId}
    className={`relative z-10 px-6 py-28 md:px-16 md:py-36 lg:px-24 ${className}`}
  >
    {children}
  </section>
);
